export default __webpack_public_path__ + "static/media/h5-bg1.1418ce26.png";